import { Modal } from "react-bootstrap";
import Icons from "../../myIcon/Icons";
import React, { useEffect, useState } from "react";

export default function HomeVideopopup({ show, onHide }) {
    const [videoSrc, setVideoSrc] = useState("");

  useEffect(() => {
    if (show) {
      setVideoSrc("https://www.youtube.com/embed/bujXoyFEaRg?autoplay=1");
    } else {
      setVideoSrc("");
    }
  }, [show]);

  return (
    <>
     <Modal className="homevideo-popup" show={show} onHide={onHide} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Body>
            <button className="popup-close" onClick={onHide}><Icons name="cross" /></button>
            {videoSrc && (
          <iframe
            className="video-player"
            src={videoSrc}
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="Video"
            frameBorder="0"
          />
        )}
        </Modal.Body>
    </Modal> 
    </>
  )
}
